import { saveSessionCache } from "./sessionCache";

/**
 * Keeps the session cache up to date: whenever the current session's selection, role, queue
 * or pending host change changes, the store's copy is written to local storage (a little
 * later, so bursts of updates cost one write). A write that fails (storage full or
 * unavailable) is tried again at the next change. Returns the unsubscribe function.
 */
export function attachSessionPersistence(store, { delayMs = 300 } = {}) {
  let last = {};
  let timer = null;

  const persist = () => {
    timer = null;
    const { session, songs } = store.getState();
    const code = session.Code;
    if (!code) return;
    const snapshot = {
      code,
      songs,
      SongId: session.SongId,
      VerseNum: session.VerseNum,
      isHost: session.isHost,
      pendingSelection: session.pendingSelection,
    };
    const unchanged =
      last.code === snapshot.code &&
      last.songs === snapshot.songs &&
      last.SongId === snapshot.SongId &&
      last.VerseNum === snapshot.VerseNum &&
      last.isHost === snapshot.isHost &&
      last.pendingSelection === snapshot.pendingSelection;
    if (unchanged) return;
    // only a successful write counts as done; otherwise the next change retries
    if (saveSessionCache(code, { session, songs })) last = snapshot;
  };

  const unsubscribe = store.subscribe(() => {
    if (timer === null) timer = setTimeout(persist, delayMs);
  });
  return () => {
    unsubscribe();
    clearTimeout(timer);
    timer = null;
  };
}
